export default __webpack_public_path__ + "static/media/hamburger.fd6f7e7f.svg";